/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DefinitionGet200Response,
  EventResponse,
  EventTimestamp,
  EventdetectorDefinition,
  EventdetectorEventList,
  EventdetectorId,
  ExportGet200Response,
} from '../models';
import {
    DefinitionGet200ResponseFromJSON,
    DefinitionGet200ResponseToJSON,
    EventResponseFromJSON,
    EventResponseToJSON,
    EventTimestampFromJSON,
    EventTimestampToJSON,
    EventdetectorDefinitionFromJSON,
    EventdetectorDefinitionToJSON,
    EventdetectorEventListFromJSON,
    EventdetectorEventListToJSON,
    EventdetectorIdFromJSON,
    EventdetectorIdToJSON,
    ExportGet200ResponseFromJSON,
    ExportGet200ResponseToJSON,
} from '../models';

export interface DefinitionGetRequest {
    useUid?: boolean;
}

export interface DefinitionIdDeleteRequest {
    id: string;
}

export interface DefinitionIdGetRequest {
    id: string;
}

export interface DefinitionIdPutRequest {
    id: string;
    eventdetectorDefinition: EventdetectorDefinition;
}

export interface DefinitionPostRequest {
    eventdetectorDefinition: EventdetectorDefinition;
    dc?: number;
}

export interface EventPostRequest {
    eventTimestamp: EventTimestamp;
}

export interface ExportGetRequest {
    start: string;
    end: string;
    serveruid: string;
    dc?: string;
}

export interface GetEventDetailsRequest {
    eventId: string;
}

/**
 * 
 */
export class EventdetectorApi extends runtime.BaseAPI {

    /**
     * Return the definitions of all eventdetectors.
     * Return all eventdetector definitions.
     */
    async definitionGetRaw(requestParameters: DefinitionGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DefinitionGet200Response>> {
        const queryParameters: any = {};

        if (requestParameters.useUid !== undefined) {
            queryParameters['use_uid'] = requestParameters.useUid;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/definition`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DefinitionGet200ResponseFromJSON(jsonValue));
    }

    /**
     * Return the definitions of all eventdetectors.
     * Return all eventdetector definitions.
     */
    async definitionGet(requestParameters: DefinitionGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DefinitionGet200Response> {
        const response = await this.definitionGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete an eventdetector definition.
     */
    async definitionIdDeleteRaw(requestParameters: DefinitionIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventdetectorDefinition>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling definitionIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/definition/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventdetectorDefinitionFromJSON(jsonValue));
    }

    /**
     * Delete an eventdetector definition.
     */
    async definitionIdDelete(requestParameters: DefinitionIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventdetectorDefinition> {
        const response = await this.definitionIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return the definition of the specified eventdetector.
     * Return eventdetector definition.
     */
    async definitionIdGetRaw(requestParameters: DefinitionIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventdetectorDefinition>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling definitionIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/definition/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventdetectorDefinitionFromJSON(jsonValue));
    }

    /**
     * Return the definition of the specified eventdetector.
     * Return eventdetector definition.
     */
    async definitionIdGet(requestParameters: DefinitionIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventdetectorDefinition> {
        const response = await this.definitionIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * Update a eventdetector
     */
    async definitionIdPutRaw(requestParameters: DefinitionIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventdetectorId>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling definitionIdPut.');
        }

        if (requestParameters.eventdetectorDefinition === null || requestParameters.eventdetectorDefinition === undefined) {
            throw new runtime.RequiredError('eventdetectorDefinition','Required parameter requestParameters.eventdetectorDefinition was null or undefined when calling definitionIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/definition/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EventdetectorDefinitionToJSON(requestParameters.eventdetectorDefinition),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventdetectorIdFromJSON(jsonValue));
    }

    /**
     * 
     * Update a eventdetector
     */
    async definitionIdPut(requestParameters: DefinitionIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventdetectorId> {
        const response = await this.definitionIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * Define an eventdetector
     */
    async definitionPostRaw(requestParameters: DefinitionPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventdetectorId>> {
        if (requestParameters.eventdetectorDefinition === null || requestParameters.eventdetectorDefinition === undefined) {
            throw new runtime.RequiredError('eventdetectorDefinition','Required parameter requestParameters.eventdetectorDefinition was null or undefined when calling definitionPost.');
        }

        const queryParameters: any = {};

        if (requestParameters.dc !== undefined) {
            queryParameters['_dc'] = requestParameters.dc;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/definition`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventdetectorDefinitionToJSON(requestParameters.eventdetectorDefinition),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventdetectorIdFromJSON(jsonValue));
    }

    /**
     * 
     * Define an eventdetector
     */
    async definitionPost(requestParameters: DefinitionPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventdetectorId> {
        const response = await this.definitionPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a list of the eventdetector events triggered since the last call.
     * Get list of eventdetector events
     */
    async eventGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventdetectorEventList>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/event`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventdetectorEventListFromJSON(jsonValue));
    }

    /**
     * Get a list of the eventdetector events triggered since the last call.
     * Get list of eventdetector events
     */
    async eventGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventdetectorEventList> {
        const response = await this.eventGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Reset the \'last call\' timestamp for the current user to the specified value.
     * Reset time of call
     */
    async eventPostRaw(requestParameters: EventPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventTimestamp>> {
        if (requestParameters.eventTimestamp === null || requestParameters.eventTimestamp === undefined) {
            throw new runtime.RequiredError('eventTimestamp','Required parameter requestParameters.eventTimestamp was null or undefined when calling eventPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/event`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventTimestampToJSON(requestParameters.eventTimestamp),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventTimestampFromJSON(jsonValue));
    }

    /**
     * Reset the \'last call\' timestamp for the current user to the specified value.
     * Reset time of call
     */
    async eventPost(requestParameters: EventPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventTimestamp> {
        const response = await this.eventPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches event detector data within a specified time range for a given server.
     * Export event detector data
     */
    async exportGetRaw(requestParameters: ExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExportGet200Response>> {
        if (requestParameters.start === null || requestParameters.start === undefined) {
            throw new runtime.RequiredError('start','Required parameter requestParameters.start was null or undefined when calling exportGet.');
        }

        if (requestParameters.end === null || requestParameters.end === undefined) {
            throw new runtime.RequiredError('end','Required parameter requestParameters.end was null or undefined when calling exportGet.');
        }

        if (requestParameters.serveruid === null || requestParameters.serveruid === undefined) {
            throw new runtime.RequiredError('serveruid','Required parameter requestParameters.serveruid was null or undefined when calling exportGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.start !== undefined) {
            queryParameters['start'] = requestParameters.start;
        }

        if (requestParameters.end !== undefined) {
            queryParameters['end'] = requestParameters.end;
        }

        if (requestParameters.serveruid !== undefined) {
            queryParameters['serveruid'] = requestParameters.serveruid;
        }

        if (requestParameters.dc !== undefined) {
            queryParameters['_dc'] = requestParameters.dc;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExportGet200ResponseFromJSON(jsonValue));
    }

    /**
     * Fetches event detector data within a specified time range for a given server.
     * Export event detector data
     */
    async exportGet(requestParameters: ExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExportGet200Response> {
        const response = await this.exportGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves details for a specific event using its event ID.
     * Get event details
     */
    async getEventDetailsRaw(requestParameters: GetEventDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventResponse>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling getEventDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/event/{eventId}`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves details for a specific event using its event ID.
     * Get event details
     */
    async getEventDetails(requestParameters: GetEventDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventResponse> {
        const response = await this.getEventDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Wait until either a eventdetector triggers, or a timeout occurs.
     * Wait for eventdetector event
     */
    async waitGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventdetectorEventList>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/wait`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventdetectorEventListFromJSON(jsonValue));
    }

    /**
     * Wait until either a eventdetector triggers, or a timeout occurs.
     * Wait for eventdetector event
     */
    async waitGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventdetectorEventList> {
        const response = await this.waitGetRaw(initOverrides);
        return await response.value();
    }

}
